


















import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class FaqQuestion extends Vue {
  @Prop({ required: true }) question!: string;

  expanded = false;

  onClick(event: Event): void {
    event.preventDefault();
    this.expanded = !this.expanded;
  }
}
